import BaseLeaveView from 'commons/views/Leave';
import {consts as LeaveRequestConsts} from 'newModels/leave-request.js';
import EmployeeChooserTpl from 'commons/templates/LeaveEmployeeChooser.html';

const EmployerLeaveView = BaseLeaveView.extend({
    _onSubmitSetLeaveRequest: function() {
        this.leaveRequest.set({
            employeeToApprove: app.user,
            employeeApprovedBy: app.user,
            employeeApprovedByName: app.user.get('name'),
            status: LeaveRequestConsts.STATUS_APPROVED
        });
    },

    _renderTemplate: function() {
        return this.template({
            employees: this.employees,
            leaveTypes: this.leaveTypes,
            leaveRequest: this.leaveRequest,
            allowHalfDays: this.allowHalfDays,
            employeeChooser: EmployeeChooserTpl({employees: this.employees})
        });
    }
});

module.exports = EmployerLeaveView;



// WEBPACK FOOTER //
// ./app/employer/views/requestLeave/Main.js